import { useQuery } from '@tanstack/react-query';
import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { authContainer } from '@/modules/auth/di/container';
import { editionsContainer } from '../../di/container';

export function useEditions() {
  const { institutionName } = useInstitutionStore();
  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: ['editions', institutionName],
    queryFn: () => editionsContainer.repository.getEditions(institutionName!),
    enabled: isAuthenticated,
    retry: false,
  });
}
